import Api from "..";
import TransmedReceivingDetail from "../../dtos/transmed/process/receivingDetail";
import transform from "../../service/transform";

export default class TransmedReceivingDetailApi extends Api {
  constructor() {
    super("transmed/receiving-detail");
  }

  public async get(): Promise<TransmedReceivingDetail[]> {
    const data = (await super.get()).data;
    if (!Array.isArray(data))
      throw new TypeError(
        "TransmedReceivingDetail entry list is not an array."
      );

    return await Promise.all(
      data.map(async (value) => await transform(TransmedReceivingDetail)(value))
    );
  }
}
